// ---------------------------------------
// PlayerSpecials.js
// Defines special player behaviour
// ---------------------------------------

import { register, pause } from '../services/players';
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils';

const PlayerSpecials = {
  Init: function () {
    const eyecatcherPlayer = document.querySelector('.c-player.-eyecatcher');

    if (!eyecatcherPlayer) {
      return;
    }

    const eyecatcherVideoId = $(eyecatcherPlayer)
      .find('iframe[data-video-id]')
      .attr('data-video-id');

    register((data = {}) => {
      const videoId = data.customData?.videoID;
      if (videoId === eyecatcherVideoId && data.eventName === 'play') {
        const eyecatcherBoundings = eyecatcherPlayer.getBoundingClientRect();
        const isInStickyMode = $(eyecatcherPlayer)
          .find('.detach-container')
          .hasClass('-detach');

        const header = document.querySelector('header.c-header');
        const headerHeight = header ? header.offsetHeight : 0;

        if (
          eyecatcherBoundings.top <
            -eyecatcherBoundings.height + headerHeight &&
          !isInStickyMode && !Utils.IsResponsive()
        ) {
          $(eyecatcherPlayer).removeClass('is-playing');
          pause(videoId);
        }
      }
    });
  },
};

export default PlayerSpecials;
